import { validMapCoordinates } from './networkMonitoringMap';

export function distanceMeters(a, b) {
    const rad = value => value * Math.PI / 180;
    const dLat = rad(b.lat - a.lat);
    const dLng = rad(b.lng - a.lng);
    const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
    return 6371000 * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(Math.max(0, 1 - h)));
}

// Connected areas can extend beyond 200m: every link between neighbours is at most 200m.
export function outageRegions(events, radius = 200) {
    const candidates = events.filter(event => event.allOffline && validMapCoordinates(event.coordinates));
    const unseen = new Set(candidates);
    const regions = [];
    while (unseen.size) {
        const first = unseen.values().next().value;
        unseen.delete(first);
        const members = [first];
        for (let i = 0; i < members.length; i++) {
            for (const other of unseen) {
                if (distanceMeters(members[i].coordinates, other.coordinates) <= radius) {
                    members.push(other);
                    unseen.delete(other);
                }
            }
        }
        if (members.length > 1) regions.push({
            id: members.map(event => event.id).sort().join(':'), members,
            affectedClients: members.reduce((sum, event) => sum + event.affectedClients, 0),
        });
    }
    return regions;
}

export const outageTime = value => {
    if (value == null) return null;
    const milliseconds = typeof value?.toMillis === 'function' ? value.toMillis()
        : typeof value === 'object' && Number.isFinite(value.seconds) ? value.seconds * 1000
            : typeof value === 'number' ? value : new Date(value).getTime();
    return Number.isFinite(milliseconds) ? milliseconds : null;
};
export const outageDate = value => outageTime(value) != null ? new Date(outageTime(value)).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }) : '—';
export function outageDuration(ms) {
    const minutes = Math.max(0, Math.floor(ms / 60000));
    return `${Math.floor(minutes / 60)}h ${minutes % 60}min`;
}

export function createOutageFocusTracker() {
    const seen = new Set();
    let initialized = false;
    return (events, fromCache = false) => {
        if (fromCache) return null;
        const arrivals = initialized ? events.filter(event => event.status === 'suspected' && !seen.has(event.id) && validMapCoordinates(event.coordinates)) : [];
        events.forEach(event => seen.add(event.id));
        initialized = true;
        return arrivals.sort((a, b) => b.alertedAt - a.alertedAt)[0] || null;
    };
}
